"use client";

import React from "react";

type LegalPageData = {
  titre: string;
  sousTitre?: string;
  contenu?: string;
};

type Props = {
  data: LegalPageData;
};

export default function LegalPageContent({ data }: Props) {
  if (!data) return null;

  return (
    <section className="bg-beige min-h-screen">
      <div className="mx-auto max-w-5xl px-6 py-16 md:px-12 md:py-24">
        <div className="mb-12 text-center">
          <h1 className="font-literata text-4xl font-bold text-black md:text-5xl lg:text-6xl">
            {data.titre}
          </h1>
          {data.sousTitre && (
            <p className="mt-6 text-xl font-medium text-text-body md:text-2xl">
              {data.sousTitre}
            </p>
          )}
        </div>

        {data.contenu && (
          <div
            className="prose prose-lg max-w-none text-text-body
              prose-headings:font-literata prose-headings:font-bold prose-headings:text-black
              prose-h2:mt-10 prose-h2:text-2xl md:prose-h2:text-3xl
              prose-h3:mt-8 prose-h3:text-xl md:prose-h3:text-2xl
              prose-p:leading-relaxed prose-p:text-lg
              prose-ul:list-disc prose-ul:pl-6
              prose-ol:list-decimal prose-ol:pl-6
              prose-li:my-2
              prose-a:text-pink prose-a:underline hover:prose-a:text-orange
              prose-strong:font-semibold"
            dangerouslySetInnerHTML={{ __html: data.contenu }}
          />
        )}
      </div>
    </section>
  );
}
